import type { Tone } from "@/lib/tutorial/types";

/** Lesson colours: gold for White's moves, violet for Black's, red threats, green support, blue ideas. */
export const TONE: Record<Tone, string> = {
  gold: "#f5b83d",
  violet: "#b48cff",
  blue: "#5aa2ff",
  green: "#3fd68b",
  red: "#ff5a52",
  white: "#f5f1e8",
};
